import { render, staticRenderFns } from "./PresupuestoNew.vue?vue&type=template&id=26f6550b&"
import script from "./PresupuestoNew.vue?vue&type=script&lang=js&"
export * from "./PresupuestoNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports